import CONSTANTS from '../constants'
import { postRequest } from '../../services'
import { APICONFIG } from '../apiConfig'
import { addEventLog } from './EventsLog'




// Calls the API to get user token
export const resetPassword = (post, user_id) => (dispatch) => {
    let postdata = { ...post, ...{ user_id: user_id }, 'device_type': 'web' }
    dispatch(addEventLog(postdata, CONSTANTS.POST_RESET_PASSWORD_REQUEST))
    dispatch({ type: CONSTANTS.POST_RESET_PASSWORD_REQUEST })
    return postRequest(APICONFIG.newresetPassword + '/' + user_id + '/reset-password', post).then((res) => {
        let resObject = { ...postdata, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.POST_RESET_PASSWORD_SUCCESS))
        dispatch({ type: CONSTANTS.POST_RESET_PASSWORD_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...postdata, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.USER_DETAILS_FAILURE))
        dispatch({ type: CONSTANTS.USER_DETAILS_FAILURE })
        return err
    })
}

export const updateProfile = (post) => (dispatch) => {
    let payload = {...post, 'device_type': 'web'}
    dispatch(addEventLog(payload, CONSTANTS.UPDATE_USER_PROFILE_REQUEST))
    dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_REQUEST })
    return postRequest(APICONFIG.updateProfile, payload).then((res) => {
        let resObject = { ...payload, ...res }
        dispatch(addEventLog(resObject, CONSTANTS.UPDATE_USER_PROFILE_SUCCESS))
        dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_SUCCESS, data: res })
        return res
    }).catch((err) => {
        let errObject = { ...payload, ...err }
        dispatch(addEventLog(errObject, CONSTANTS.UPDATE_USER_PROFILE_FAILURE))
        dispatch({ type: CONSTANTS.UPDATE_USER_PROFILE_FAILURE })
        return err
    })
}





